<template>
  <div>
    <div class="text-sm-right mb-4">
      <v-btn
        v-if="checkAuthorization('contact-source_create')"
        class="primary mx-0"
        @click="addContactSource"
      >
        <v-icon>mdi-plus</v-icon>Thêm
      </v-btn>
    </div>

    <v-simple-table class="table-layout">
      <template v-slot:default>
        <thead>
          <tr>
            <th class="th-id">
              #
            </th>
            <th>Nguồn khách hàng</th>
            <th>Mã</th>
            <th>Mô tả</th>
            <th>Trạng thái</th>
            <th v-if="showAction">Thao tác</th>
          </tr>
        </thead>
        <tbody>
          <template v-for="(contact, index) in contacts">
            <tr
              :key="contact.id"
            >
              <td>{{ index + 1 }}</td>
              <td>{{ contact.name }}</td>
              <td>{{ contact.code }}</td>
              <td>{{ contact.description }}</td>
              <td>{{ _.get(contactSourceStatusOptions.find(status => status.value === contact.status), 'text', '') }}</td>
              <td v-if="showAction">
                <div class="action">
                  <v-tooltip bottom v-if="checkAuthorization('contact-source_update')">
                    <template v-slot:activator="{ on }">
                      <v-btn class="mr-2" @click="editContactSource(contact)" icon small color="primary"  v-on="on"><v-icon>mdi-pencil</v-icon></v-btn>
                    </template>
                    <span>Cập nhật thông tin nguồn khách hàng</span>
                  </v-tooltip>
                  <v-tooltip bottom v-if="checkAuthorization('contact-source_delete')">
                    <template v-slot:activator="{ on }">
                      <v-btn @click="delelteContactSource(contact)" icon small color="default"  v-on="on"><v-icon>mdi-delete</v-icon></v-btn>
                    </template>
                    <span>Xóa nguồn khách hàng</span>
                  </v-tooltip>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
      </template>
    </v-simple-table>
    <contact-source-form-modal :contact="selectedContact" />
  </div>
</template>
<script>
  import ContactSourceFormModal from './ContactSourceFormModal.vue'
  import RepositoryFactory from '../../../repositories/RepositoryFactory'
  import { contactSourceStatusOptions, contactSourceStatus } from '../../../helpers/constants'
  const ContactSourceRepository = RepositoryFactory.get('contact_source')
  export default {
    components: { ContactSourceFormModal },
    props: {
      filterForm: {
        type: Object,
        default: () => {},
      },
      contacts: {
        type: Array,
        default: () => {},
      },
    },
    data () {
      return {
        selectedContact: {},
        contactSourceStatusOptions,
      }
    },
    computed: {
      showAction() {
        return this.checkAuthorization('contact-source_delete') || this.checkAuthorization('contact-source_update');
      }
    },
    created () {
    },
    methods: {
      addContactSource () {
        this.selectedContact = {
          status: contactSourceStatus.ACTIVE,
        }
        Bus.$emit('show-contact-form-modal', this.selectedContact)
      },
      editContactSource (contact) {
        this.selectedContact = contact
        Bus.$emit('show-contact-form-modal', this.selectedContact)
      },
      async delelteContactSource (contact) {
        this.$swal({
          title: 'Xóa khách hàng',
          text: 'Bạn có thực sự muốn xoá ?',
          type: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Đồng ý',
          cancelButtonText: 'Hủy bỏ',
        }).then(async (result) => {
          if (result.value) {
            const loader = this.$loading.show()
            const respond = await ContactSourceRepository.delete(contact.id)
            loader.hide()
            if (_.get(respond, 'success', false)) {
              this.$swal({
                title: 'Xoá thành công !',
                confirmButtonText: 'Đồng ý',
              },
              ).then(() => {
                Bus.$emit('contact-source-list-reload')
              })
            } else {
              this.$swal({
                type: 'error',
                title: 'Lỗi !',
                text: _.get(respond, 'message', ''),
              })
            }
          }
        })
      },
    },
  }
</script>
